import React from 'react';

import { HeightOutlined } from '@mui/icons-material';

import createBlockInputSection from './helpers/createBlockInputSection';
import HideSectionInput from './special-inputs/HideSectionInput';

const DividerSidebarForm = createBlockInputSection({
  title: 'Divider block',
  inputs: [
    {
      type: 'color',
      props: {
        label: 'Color',
        name: 'lineColor',
      },
    },
    {
      type: 'slider',
      props: {
        name: 'lineHeight',
        label: 'Height',
        iconLabel: <HeightOutlined sx={{ color: 'text.secondary' }} />,
        units: 'px',
        step: 1,
        min: 1,
        max: 24,
      },
    },
    'backgroundColor',
    'padding',
    HideSectionInput,
  ],
});

export default DividerSidebarForm;
